// src/components/UserDashboard/UserDashboard/BottomNavigation.js
import React from 'react';

const BottomNavigation = ({ activeTab, setActiveTab, language = 'th' }) => {
  const translations = {
    th: { saved: 'ที่บันทึกไว้', friends: 'เพื่อน', calendar: 'ปฏิทิน', coupons: 'คูปอง' },
    en: { saved: 'Saved', friends: 'Friends', calendar: 'Calendar', coupons: 'Coupons' },
    zh: { saved: '已保存', friends: '好友', calendar: '日历', coupons: '优惠券' }
  };

  const t = translations[language] || translations.th;

  const navItems = [
    { id: 'saved',    icon: 'fas fa-bookmark',    label: t.saved },
    { id: 'friends',  icon: 'fas fa-users',        label: t.friends },
    { id: 'calendar', icon: 'fas fa-calendar',     label: t.calendar },
    { id: 'coupons',  icon: 'fas fa-ticket-alt',   label: t.coupons },
  ];

  return (
    <nav className="bottom-nav enhanced">
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
          onClick={() => setActiveTab(item.id)}
        >
          <div className="nav-icon-wrapper">
            <i className={item.icon}></i>
            {activeTab === item.id && <div className="active-indicator"></div>}
          </div>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNavigation;
